import { apiClient } from "./NetworkService";
// @ts-ignore
import ApiNames from "../constants/ApiNames";
import { Config } from "../constants/Config";
import type { ApiResponse } from "../types/home";
import type {
  TipType,
  JoinQuranClassRequest,
  JoinQuranClassResponse,
  QuizTopic,
  SearchData,
  UtmsResponse,
  EnrichmentResponse,
} from "../types/misc";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getTipsAll = async (token?: string): Promise<ApiResponse<TipType[]>> => {
  const res = await apiClient.get(ApiNames.tipsAll, getHeaders(token));
  return res.data;
};

export const getQuranClass = async (token?: string): Promise<ApiResponse<any>> => {
  const res = await apiClient.get(ApiNames.quranClass, getHeaders(token));
  return res.data;
};

export const joinQuranClass = async (data: JoinQuranClassRequest, token?: string): Promise<ApiResponse<JoinQuranClassResponse>> => {
  const res = await apiClient.post(ApiNames.joinQuranClass, data, getHeaders(token));
  return res.data;
};

export const getQuizTopics = async (topicId: string | number, token?: string): Promise<ApiResponse<QuizTopic[]>> => {
  const res = await apiClient.get(`${ApiNames.quizTopics}?topicId=${topicId}`, getHeaders(token));
  return res.data;
};

export const getSearchData = async (token?: string): Promise<ApiResponse<SearchData>> => {
  const res = await apiClient.get(ApiNames.searchData, getHeaders(token));
  return res.data;
};

export const getUtms = async (token?: string): Promise<ApiResponse<UtmsResponse>> => {
  const res = await apiClient.get(ApiNames.utms, getHeaders(token));
  return res.data;
};

export const getEnrichment = async (token?: string): Promise<ApiResponse<EnrichmentResponse>> => {
  // Enrichment (header enrichment) must run over http so the carrier can inject
  // MSISDN headers; every other API stays on https.
  const httpBaseUrl = Config.BASE_URL.replace(/^https:\/\//, "http://");
  const res = await apiClient.get(ApiNames.enrichment, {
    ...getHeaders(token),
    baseURL: httpBaseUrl,
  });
  return res.data;
};
